import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import css from './Summary.module.css';
import { FormattedMessage } from 'react-intl';
import { priceData } from '../../../../components/ListingCard/ListingCard';
import { Money } from '../../../../util/currency';
import { PrimaryButton } from '../../../../components';
import getCountryCodes from '../../../../translations/countryCodes';
import config from '../../../../config';
import { ERROR_CODE_TRANSACTION_BOOKING_TIME_NOT_AVAILABLE } from '../../../../util/types';
import { InfoCard } from '../InfoCard';
function CartOrderSummary({
  subtotal,
  handleOpenModal,
  country,
  sellerId,
  intl,
  currency,
  shippingCost,
  sellerName,
  handleStorePurchase,
  purchaseData,
  currentUser,
  editAmount,
  removeItem,
}) {
  const [shippingFeeFormatted, setShippingFeeFormatted] = useState(
    `${currency}0`
  );
  const countryCodes = getCountryCodes(config.locale);

  useEffect(() => {
    const { formattedPrice: tempFee, priceTitle: tempFeeTitle } = priceData(
      shippingCost == 'forbidden' ? new Money(0, currency) : shippingCost,
      intl
    );
    setShippingFeeFormatted(tempFee);
  }, [shippingCost]);

  const { formattedPrice: subttl, priceTitle: totalCurrency } = priceData(
    new Money(subtotal, currency),
    intl
  );

  const { formattedPrice: total, priceTitle: totalTitle } = priceData(
    new Money(
      shippingCost && shippingCost != 'forbidden'
        ? subtotal + shippingCost.amount
        : 0,
      currency
    ),
    intl
  );

  const isProductWithNoStockAdded = purchaseData.products.some(
    product => product.stock.attributes.quantity == 0
  );
  const isOwnProduct = sellerId === currentUser?.id.uuid;

  return (
    <div className={css.root}>
     
      <h3 className={css.title}>
        Your cart with {purchaseData.sellerName}
      </h3>

      {purchaseData.products?.map(cartItem => {
        return (
          <InfoCard
            editAmount={editAmount}
            removeItem={removeItem}
            key={cartItem.id.uuid}
            item={cartItem}
            intl={intl}
            currentUser={currentUser}
          />
        );
      })}

      <p className={`${css.SummaryInfo} ${css.textWithSpan}`}>
        <FormattedMessage id="ShoppingCart.Subtotal" />
        <span>{subttl}</span>
      </p>
      {shippingCost == 'forbidden' ? null : (
        <p className={`${css.SummaryInfo} ${css.textWithSpan}`}>
          <FormattedMessage id="ShoppingCart.Shipping" />
          <span>{shippingFeeFormatted}</span>
        </p>
      )}
      <button
        id={sellerId}
        onClick={handleOpenModal}
        className={css.shippingRegion}
      >{`(to ${
        countryCodes.find(x => x.code == country[sellerId])?.name
      })`}</button>

      <p className={`${css.SummaryTotal} ${css.textWithSpan}`}>
        <FormattedMessage id="ShoppingCart.Total" /> <span>{total}</span>
      </p>

      <div className={css.checkoutButton}>
        <PrimaryButton
          onClick={() => {
            if (
              shippingCost != 'forbidden' ||
              !isProductWithNoStockAdded ||
              !isOwnProduct
            ) {
              handleStorePurchase(sellerId, purchaseData.products[0].id.uuid);
            }
          }}
          className={css.checkoutButton}
          disabled={
            shippingCost == 'forbidden' ||
            isProductWithNoStockAdded ||
            isOwnProduct
          }
        >
          <FormattedMessage id="ShoppingCart.CheckoutButton" />
           {' '} {sellerName}
        </PrimaryButton>
      </div>
      {shippingCost == 'forbidden' ? (
        <div className={css.shippingError}>
          {' '}
          It is not possible to ship to this country.
        </div>
      ) : null}
      {isOwnProduct ? (
        <div className={css.shippingError}>
          You cannot buy from your own shop
        </div>
      ) : null}
      {isProductWithNoStockAdded ? (
        <div className={css.shippingError}>
          Please remove out of stock items from the cart
        </div>
      ) : null}
    </div>
  );
}

CartOrderSummary.propTypes = {};

export default CartOrderSummary;
